import React from 'react';
import './components.css';

function Visit() {
  return (
    <section className="visit" id="visit">
      <div className="container">
        <div>
          <span className="kicker">05 — Find Us</span>
          <h2 className="section-title">Come spend an afternoon.</h2>
          <p className="visit-lede">
            The kettle's on, the chairs are open, and there's almost certainly a book with your name on it.
          </p>

          <div className="visit-details">
            <div className="visit-block">
              <h4>Address</h4>
              <p>
                The Happy Book Stack<br />
                452 W Center St #105<br />
                Pleasant Grove, UT 84062
              </p>
            </div>

            <div className="visit-block">
              <h4>Hours</h4>
              <p>
                Monday - Thursday · 10 AM - 6 PM<br />
                Friday · 10 AM - 7 PM<br />
                Saturday · 9 AM - 7 PM<br />
                Sunday · Closed
              </p>
            </div>

            <div className="visit-block">
              <h4>Say Hello</h4>
              <p>
                <a href="mailto:thehappybookstackutah@gmail.com">thehappybookstackutah@gmail.com</a>
              </p>
            </div>

            <div className="visit-block">
              <h4>Storytime</h4>
              <p>
                Every Thursday<br />
                10 – 11 AM · Free
              </p>
            </div>
          </div>
        </div>

        <div className="visit-map" aria-label="Map to the bookstore">
          <span className="visit-map-tag">Find us on the map ↗</span>
        </div>
      </div>
    </section>
  );
}

export default Visit;
